export default {
  install(Vue, options = {}) {
    Vue.directive("bgImg", {
      inserted: (el, { value }) => {
        el.style.backgroundImage = `url(${value})`;
      },
      update: (el, { value }) => {
        el.style.backgroundImage = `url(${value})`;
      },
    });
  },
};
